import React, { useEffect, useState } from "react";

import UniversalPageHeader from "../components/UniversalPageHeader";
import "../styles/FAQs.css";

export default function FAQs() {
  const [title, setTitle] = useState("FAQs");

  const actions = [
    { link: "/", actionTitle: "Home" },
    { link: "/shop", actionTitle: "Shop" },
  ];
  const faqs = [
    {
      question: "How do I ensure the waterproof pocket remains fully sealed?",
      answer:
        "To maintain a secure seal, always ensure the zipper is completely closed. Slide it firmly to the end of its track, checking that no gaps remain before entering the water.",
    },
    {
      question:
        "What is the best way to clean my swim shorts with a waterproof pocket?",
      answer:
        "For optimal longevity, follow the care instructions on the label. In most cases, machine washing on a gentle cycle is recommended. Avoid high heat when drying to preserve the integrity of the waterproof seal.",
    },
    {
      question:
        "Are there any items I should avoid placing in the waterproof pocket?",
      answer:
        "Yes. We advise against storing sharp objects that could compromise the waterproof membrane. Additionally, items sensitive to pressure changes, such as certain electronics, may not be suitable for deep-water activities.",
    },
    {
      question:
        "How deep can I dive while keeping items in the waterproof pocket?",
      answer:
        "Our waterproof pocket is designed for surface swimming and light snorkeling, ensuring protection at depths of up to 5 meters. For extended or deep-water diving, we recommend consulting the product specifications.",
    },
    {
      question: "What should I do if water enters the waterproof pocket?",
      answer:
        "In the rare event of a leak, promptly remove and dry the contents. If you experience any issues, please reach out to our customer service team via our contact form for assistance.",
    },
  ];

  // Dynamically set the title based on screen size
  useEffect(() => {
    const updateTitle = () => {
      if (window.innerWidth < 768) {
        setTitle("FAQs");
      } else {
        setTitle("Frequently Asked Questions");
      }
    };

    // Set the title on initial render and when resizing the window
    updateTitle();
    window.addEventListener("resize", updateTitle);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", updateTitle);
    };
  }, []);

  return (
    <div className="faqs-container">
      <UniversalPageHeader
        title={title}
        // subtitle="Most queries can be resolved quickly by having a quick read of our FAQs"
        actions={actions}
      />
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <h2 className="faq-question">{faq.question}</h2>
            <p className="faq-answer">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
